import React from 'react';
export var pills = [{
  text: 'Calcula tu perfil inversor',
  path: '/pildoras/conoce-tu-perfil-inversor',
  show: true
}, {
  text: '¿Cuánto puedo ganar invirtiendo a largo plazo?',
  path: '/pildoras/cuanto-tendras-segun-riesgo-asumido',
  show: true
}, {
  text: 'Calculadora inflación',
  path: '/pildoras/valor-ahorros-inflacion',
  show: true
}, {
  text: 'Calculadora finanzas personales',
  path: '/pildoras/salud-financiera',
  show: true
}, {
  text: '¿Cuánto te retiene Hacienda del sueldo?',
  path: '/pildoras/calcula-tus-retenciones',
  show: true
}, {
  text: 'Calculadora de sueldo neto',
  path: '/pildoras/calculadora-sueldo-neto',
  show: true
}];
export var investments = [{
  text: 'Mejores fondos de inversión',
  path: '/usuario/maitelpz/articulos/claves-encontrar-mejores-fondos-inversion',
  show: true
}, {
  text: 'Mejores planes de pensiones',
  path: '/usuario/carlosalosete/articulos/Los_mejores_planes_de_pensiones',
  show: true
}, {
  text: 'Mejores ETFs',
  path: '/usuario/avillanuevae/articulos/mejores-etfs-para-invertir-en-2024',
  show: true
}, {
  text: 'Mejores brokers',
  path: '/usuario/AsunInfante/articulos/mejores-brokers-online-empezar-invertir',
  show: true
}, {
  text: 'Mejores exchanges de cripto',
  path: '/usuario/avillanuevae/articulos/mejores-exchanges-y-brokers-para-invertir-en-criptomonedas',
  show: true
}, {
  text: 'Mejores roboadvisors',
  path: '/usuario/Kaloxa/articulos/comparativa-roboadvisors-carteras-indexadas',
  show: true
}];
export var personalFinances = [{
  text: 'Mejores cuentas remuneradas',
  path: '/usuario/AsunInfante/articulos/mejores-cuentas-remuneradas',
  show: true
}, {
  text: 'Mejores cuentas nómina',
  path: '/usuario/sandraalquezar/articulos/mejores-cuentas-nomina-sin-comisiones',
  show: true
}, {
  text: 'Mejores depósitos a plazo fijo',
  path: '/usuario/eduardogarcia/articulos/los-mejores-depositos-bancarios-a-plazo-fijo',
  show: true
}, {
  text: 'Mejores hipotecas',
  path: '/articulos/mejores-hipotecas',
  show: true
}, {
  text: 'Evolución del euríbor',
  path: '/euribor',
  show: true
}, {
  text: 'Mejores seguros de salud',
  path: '/usuario/sandraalquezar/articulos/cuales-son-los-mejores-seguros-de-salud-de-espana',
  show: true
}];
export var legal = [{
  text: 'Política de cookies',
  path: '/terminos-legales/politica-de-cookies',
  show: true
}, {
  text: 'Términos legales',
  path: '/terminos-legales',
  show: true
}, {
  text: 'Código ético',
  path: '/codigo-etico',
  show: true
}, {
  text: 'Sobre nosotros',
  path: '/sobre-finect',
  show: false
}, {
  text: 'Accede a Finect',
  path: '/login',
  show: false
}];
export var socials = [{
  name: 'Facebook',
  link: 'https://facebook.com/finect',
  icon: React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7574 2.75736C11.8826 1.63214 13.4087 1 15 1H18C18.5523 1 19 1.44772 19 2V6C19 6.55228 18.5523 7 18 7H15V9H18C18.3079 9 18.5987 9.14187 18.7882 9.38459C18.9777 9.6273 19.0448 9.94379 18.9701 10.2425L17.9701 14.2425C17.8588 14.6877 17.4589 15 17 15H15V22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V15H7C6.44772 15 6 14.5523 6 14V10C6 9.44772 6.44772 9 7 9H9V7C9 5.4087 9.63214 3.88258 10.7574 2.75736ZM15 3C13.9391 3 12.9217 3.42143 12.1716 4.17157C11.4214 4.92172 11 5.93913 11 7V10C11 10.5523 10.5523 11 10 11H8V13H10C10.5523 13 11 13.4477 11 14V21H13V14C13 13.4477 13.4477 13 14 13H16.2192L16.7192 11H14C13.4477 11 13 10.5523 13 10V7C13 6.46957 13.2107 5.96086 13.5858 5.58579C13.9609 5.21071 14.4696 5 15 5H17V3H15Z",
    fill: "#D5D5D6"
  }))
}, {
  name: 'Twitter',
  link: 'https://twitter.com/finect',
  icon: React.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1921 2.35024C16.2409 1.94993 17.3873 1.88139 18.4764 2.15388C19.3424 2.37057 20.1389 2.7946 20.7992 3.38515C21.6114 3.08663 22.3817 2.68262 23.0902 2.18288L23.6666 3.00005L24.6382 3.23666C24.2957 4.64319 23.6091 5.93961 22.6435 7.01102C22.6583 7.17242 22.6661 7.33448 22.6666 7.49674L22.6666 7.50005C22.6666 13.6 19.7297 18.0751 15.5115 20.3203C11.3175 22.5525 5.95748 22.5278 1.18096 19.8742C0.776153 19.6493 0.578707 19.1759 0.703756 18.73C0.828804 18.2841 1.24363 17.9824 1.70635 18.0008C3.39317 18.0679 5.06298 17.7325 6.58134 17.033C5.07819 16.1055 3.99603 15.0043 3.24366 13.8163C2.24003 12.2317 1.86116 10.5529 1.79264 9.04545C1.72431 7.54233 1.96309 6.18894 2.21409 5.21841C2.34019 4.73082 2.47103 4.33355 2.57188 4.05458C2.62237 3.91493 2.66552 3.80446 2.69705 3.72663C2.71282 3.6877 2.7257 3.65689 2.73516 3.63464L2.74674 3.60771L2.74969 3.60096C2.75673 3.58478 2.76423 3.56873 2.77218 3.55283L3.66661 4.00005L4.48496 3.42534C5.4005 4.72901 6.62425 5.78604 8.04721 6.50226C9.17906 7.07196 10.409 7.41197 11.6663 7.50646C11.6589 6.3968 11.9886 5.3107 12.6122 4.3921C13.2427 3.4633 14.1433 2.75054 15.1921 2.35024ZM4.07125 6.04365C3.88756 6.84502 3.74088 7.86128 3.79058 8.95464C3.84705 10.1971 4.15568 11.5184 4.9333 12.7462C5.70689 13.9677 6.98265 15.1573 9.07275 16.0862C9.40455 16.2337 9.63035 16.5494 9.66264 16.9111C9.69494 17.2728 9.52866 17.6235 9.22824 17.8274C8.1173 18.5815 6.90081 19.1489 5.62671 19.5157C8.79687 20.3234 11.9736 19.9377 14.5718 18.5548C18.1031 16.6752 20.6661 12.9009 20.6666 7.50171C20.6658 7.28562 20.645 7.07006 20.6044 6.8578C20.5417 6.52994 20.6468 6.19242 20.8844 5.95804C21.1072 5.73835 21.3135 5.50421 21.5023 5.25755C21.2758 5.3411 21.0466 5.41783 20.8149 5.48758C20.4383 5.60099 20.0302 5.48308 19.7721 5.18628C19.3042 4.64837 18.6825 4.26711 17.9909 4.09407C17.2993 3.92102 16.5713 3.96455 15.9053 4.21876C15.2392 4.47297 14.6674 4.9256 14.267 5.51542C13.8666 6.10525 13.657 6.80381 13.6665 7.51664L13.6667 7.53005H13.6666V8.53005C13.6666 9.07223 13.2345 9.51566 12.6925 9.52971C10.7703 9.57955 8.86559 9.15324 7.14802 8.28872C6.00245 7.71212 4.96385 6.95253 4.07125 6.04365Z",
    fill: "#D5D5D6"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    x: "0.666626",
    width: "24",
    height: "24",
    fill: "white"
  }))))
}, {
  name: 'Linkedin',
  link: 'https://www.linkedin.com/company/finect/',
  icon: React.createElement("svg", {
    width: "24",
    height: "23",
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1111 8.62492C14.8403 8.62492 13.6215 9.12975 12.7229 10.0284C11.8243 10.927 11.3194 12.1458 11.3194 13.4166V19.1666H13.2361V13.4166C13.2361 12.6541 13.539 11.9228 14.0782 11.3837C14.6173 10.8445 15.3486 10.5416 16.1111 10.5416C16.8736 10.5416 17.6049 10.8445 18.144 11.3837C18.6832 11.9228 18.9861 12.6541 18.9861 13.4166V19.1666H20.9028V13.4166C20.9028 12.1458 20.3979 10.927 19.4993 10.0284C18.6007 9.12975 17.3819 8.62492 16.1111 8.62492ZM16.1111 6.70825C14.3319 6.70825 12.6257 7.41502 11.3676 8.67308C10.1095 9.93113 9.40277 11.6374 9.40277 13.4166V20.1249C9.40277 20.6542 9.83183 21.0833 10.3611 21.0833H14.1944C14.7237 21.0833 15.1528 20.6542 15.1528 20.1249V13.4166C15.1528 13.1624 15.2537 12.9187 15.4335 12.7389C15.6132 12.5592 15.8569 12.4583 16.1111 12.4583C16.3653 12.4583 16.609 12.5592 16.7887 12.7389C16.9685 12.9187 17.0694 13.1624 17.0694 13.4166V20.1249C17.0694 20.6542 17.4985 21.0833 18.0278 21.0833H21.8611C22.3904 21.0833 22.8194 20.6542 22.8194 20.1249V13.4166C22.8194 11.6374 22.1127 9.93113 20.8546 8.67308C19.5966 7.41502 17.8903 6.70825 16.1111 6.70825Z",
    fill: "#D5D5D6"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73611 8.62508C1.73611 8.09581 2.16517 7.66675 2.69445 7.66675H6.52778C7.05705 7.66675 7.48611 8.09581 7.48611 8.62508V20.1251C7.48611 20.6544 7.05705 21.0834 6.52778 21.0834H2.69445C2.16517 21.0834 1.73611 20.6544 1.73611 20.1251V8.62508ZM3.65278 9.58341V19.1667H5.56945V9.58341H3.65278Z",
    fill: "#D5D5D6"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61111 2.87492C4.08184 2.87492 3.65278 3.30398 3.65278 3.83325C3.65278 4.36252 4.08184 4.79158 4.61111 4.79158C5.14039 4.79158 5.56945 4.36252 5.56945 3.83325C5.56945 3.30398 5.14039 2.87492 4.61111 2.87492ZM1.73611 3.83325C1.73611 2.24543 3.0233 0.958252 4.61111 0.958252C6.19893 0.958252 7.48611 2.24543 7.48611 3.83325C7.48611 5.42107 6.19893 6.70825 4.61111 6.70825C3.0233 6.70825 1.73611 5.42107 1.73611 3.83325Z",
    fill: "#D5D5D6"
  }))
}, {
  name: 'Instagram',
  link: 'https://instagram.com/finect/',
  icon: React.createElement("svg", {
    width: "23",
    height: "22",
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M16.0532 1.8103H7.0023C4.50296 1.8103 2.47684 3.83642 2.47684 6.33577V15.3867C2.47684 17.886 4.50296 19.9122 7.0023 19.9122H16.0532C18.5526 19.9122 20.5787 17.886 20.5787 15.3867V6.33577C20.5787 3.83642 18.5526 1.8103 16.0532 1.8103Z",
    stroke: "#D5D5D6",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15.1481 10.291C15.2598 11.0442 15.1312 11.8135 14.7804 12.4895C14.4297 13.1654 13.8748 13.7135 13.1946 14.0559C12.5144 14.3982 11.7436 14.5174 10.9918 14.3964C10.2399 14.2754 9.54539 13.9205 9.00693 13.382C8.46847 12.8436 8.11351 12.149 7.99253 11.3972C7.87155 10.6454 7.99072 9.87455 8.33308 9.19435C8.67544 8.51416 9.22357 7.95923 9.89949 7.60851C10.5754 7.25779 11.3447 7.12912 12.098 7.24082C12.8663 7.35476 13.5777 7.7128 14.1269 8.26205C14.6762 8.81129 15.0342 9.52263 15.1481 10.291Z",
    stroke: "#D5D5D6",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.5058 5.88306H16.5136",
    stroke: "#D5D5D6",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))
}, {
  name: 'Youtube',
  link: 'https://www.youtube.com/finect',
  icon: React.createElement("svg", {
    width: "24",
    height: "23",
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7776 2.875C11.7777 2.875 11.7778 2.875 11.7778 3.83333L11.7778 4.79167L11.7055 4.79177C11.6575 4.79188 11.5867 4.79209 11.4958 4.79252C11.3139 4.79337 11.0519 4.79508 10.7321 4.7985C10.0921 4.80535 9.22285 4.81903 8.30354 4.84635C7.3827 4.87371 6.41936 4.91454 5.58898 4.9751C4.73788 5.03718 4.10549 5.11521 3.79041 5.19819C3.50416 5.28042 3.24438 5.43617 3.03696 5.65001C2.83462 5.8586 2.68905 6.11531 2.61383 6.39568C2.32677 7.99956 2.18639 9.62628 2.19444 11.2557L2.19449 11.2664C2.18422 12.9025 2.32354 14.5361 2.61082 16.1467C2.69384 16.4128 2.84088 16.6547 3.0393 16.8511C3.24717 17.0568 3.50443 17.2056 3.78637 17.2832C4.10006 17.3666 4.73422 17.4451 5.58898 17.5074C6.41936 17.568 7.3827 17.6088 8.30354 17.6362C9.22285 17.6635 10.0921 17.6772 10.7321 17.684C11.0519 17.6874 11.3139 17.6891 11.4958 17.69C11.5867 17.6904 11.6575 17.6906 11.7055 17.6907H11.8501C11.8981 17.6906 11.9689 17.6904 12.0598 17.69C12.2417 17.6891 12.5037 17.6874 12.8235 17.684C13.4634 17.6772 14.3327 17.6635 15.252 17.6362C16.1729 17.6088 17.1362 17.568 17.9666 17.5074C18.8177 17.4453 19.4501 17.3673 19.7652 17.2843C20.0514 17.2021 20.3112 17.0463 20.5186 16.8325C20.7209 16.6239 20.8665 16.3672 20.9417 16.0868C21.2266 14.4951 21.3669 12.8809 21.3611 11.2639L21.3611 11.2544C21.3714 9.61264 21.2311 7.97341 20.9417 6.35736C20.8665 6.07698 20.7209 5.82027 20.5186 5.61168C20.3136 5.40029 20.0574 5.24566 19.775 5.16271C19.4492 5.08607 18.8145 5.01542 17.9726 4.95935C17.1406 4.90394 16.1759 4.86663 15.2545 4.84163C14.3345 4.81667 13.4647 4.80416 12.8244 4.79791C12.5044 4.79478 12.2422 4.79322 12.0602 4.79244L11.8503 4.79176L11.7778 4.79167L11.7778 3.83333C11.7778 2.875 11.7777 2.875 11.7776 2.875L11.8542 2.8751C11.9035 2.8752 11.9759 2.8754 12.0684 2.87579C12.2534 2.87659 12.5192 2.87817 12.8431 2.88133C13.4906 2.88766 14.3721 2.90031 15.3065 2.92567C16.2395 2.95098 17.2322 2.98913 18.1 3.04692C18.943 3.10306 19.743 3.18183 20.2468 3.30485C20.258 3.3076 20.2692 3.31055 20.2803 3.3137C20.8938 3.48724 21.4505 3.81959 21.8944 4.27718C22.3382 4.73477 22.6535 5.30139 22.8083 5.91981L21.8786 6.1525L22.8217 5.98238C23.136 7.72436 23.2886 9.49164 23.2778 11.2617C23.2838 13.0053 23.1311 14.7458 22.8217 16.4617C22.818 16.4827 22.8135 16.5036 22.8083 16.5244C22.6535 17.1428 22.3382 17.7094 21.8944 18.167C21.4505 18.6246 20.8938 18.9569 20.2803 19.1305L20.267 19.1341C19.7556 19.2709 18.9487 19.3575 18.106 19.419C17.2365 19.4824 16.2425 19.5242 15.309 19.552C14.3739 19.5798 13.4918 19.5936 12.844 19.6006C12.5199 19.604 12.254 19.6058 12.0688 19.6066C11.9762 19.6071 11.9038 19.6073 11.8544 19.6074L11.7782 19.6075L11.7012 19.6074C11.6518 19.6073 11.5794 19.6071 11.4868 19.6066C11.3016 19.6058 11.0357 19.604 10.7116 19.6006C10.0638 19.5936 9.18168 19.5798 8.24661 19.552C7.31307 19.5242 6.31902 19.4824 5.44955 19.419C4.60689 19.3575 3.79993 19.2709 3.28852 19.1341L3.28319 19.1327C2.68225 18.9683 2.13388 18.6516 1.69105 18.2134C1.24822 17.7751 0.925913 17.23 0.755266 16.6308C0.746604 16.6004 0.739452 16.5696 0.733838 16.5385C0.419659 14.7967 0.266989 13.0296 0.27777 11.2598C0.269419 9.50317 0.422077 7.7495 0.733831 6.02076C0.737621 5.99974 0.742112 5.97886 0.747297 5.95814C0.902085 5.33973 1.21733 4.77311 1.66119 4.31552C2.10505 3.85793 2.66181 3.52558 3.27523 3.35203L3.28852 3.34837C3.79993 3.2116 4.60689 3.12498 5.44955 3.06352C6.31902 3.0001 7.31307 2.95827 8.24661 2.93053C9.18168 2.90274 10.0638 2.88887 10.7116 2.88194C11.0357 2.87848 11.3016 2.87674 11.4868 2.87587C11.5794 2.87544 11.6518 2.87522 11.7012 2.87511L11.7776 2.875Z",
    fill: "#D5D5D6"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13967 7.29841C9.43466 7.12682 9.79864 7.12504 10.0953 7.29375L15.6057 10.4275C15.9053 10.5979 16.0903 10.9159 16.0903 11.2605C16.0903 11.6052 15.9053 11.9232 15.6057 12.0936L10.0953 15.2273C9.79864 15.396 9.43466 15.3943 9.13967 15.2227C8.84469 15.0511 8.66321 14.7356 8.66321 14.3943V8.12679C8.66321 7.78553 8.84469 7.47001 9.13967 7.29841ZM10.5799 9.77426V12.7468L13.1934 11.2605L10.5799 9.77426Z",
    fill: "#D5D5D6"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    x: "0.277786",
    width: "23",
    height: "23",
    fill: "white"
  }))))
}];